import { Fragment } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useGlobalPcSetQuery } from '@/entities/pricing-campaign'

import CheckWaveIcon from '@/shared/components/icons/CheckWaveIcon'
import { Spinner } from '@/shared/components/ui/spinner'
import { Table, TableBody } from '@/shared/components/ui/table'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'

import { OptimizationGroupsItem } from './OptimizationGroupItem'

export const GlobalSetItem = ({ id }: { id: string }) => {
	const { t } = useTranslation()

	const { data: globalSet, isLoading } = useGlobalPcSetQuery(id)

	return (
		<Fragment key={id}>
			<div className='flex items-center gap-2'>
				{isLoading ? (
					<Spinner />
				) : (
					<div className='flex items-center space-x-2'>
						<span className='text-sm font-semibold'>{globalSet?.name}</span>
						{globalSet?.is_main && (
							<Tooltip>
								<TooltipTrigger asChild>
									<CheckWaveIcon />
								</TooltipTrigger>
								<TooltipContent>{t('app.live')}</TooltipContent>
							</Tooltip>
						)}
					</div>
				)}
			</div>
			<GlobalSetContent id={id} />
		</Fragment>
	)
}

const GlobalSetContent = ({ id }: { id: string }) => {
	const optimizationGroupIds = useWatch({ name: 'optimizationGroupIds' })

	return (
		<div className='overflow-hidden rounded-md border'>
			<Table
				data-slot='table'
				className='table-fixed overflow-hidden text-left text-sm'
			>
				<TableBody>
					{optimizationGroupIds?.map((optimizationGroupId: string) => (
						<OptimizationGroupsItem
							id={optimizationGroupId}
							key={optimizationGroupId}
							name={`selectedValues.${id}.${optimizationGroupId}`}
						/>
					))}
				</TableBody>
			</Table>
		</div>
	)
}
